module.exports = __webpack_public_path__ + "static/media/popup_close.260fb93f.svg";